

import moment from 'moment';

import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: "rotas-timeline",
    props: {
      rotas: {
        type: Array,
        default: () => {
          [];
        },
      }
    },
    methods: {
    async gotoPedido(pedido:any){
        this.$router.push(`/pedidos/${pedido.id_pedido}`);
    },
    closeAll() {
      //this.rotas.forEach((item) => (item.open = false));
    },
    fDate(date:any){
        return moment(date).format('H') + 'h';
    },
    getIconeByStatus(status:Number) {
        if (status === 0) return 'ni ni-box-2'; // Pedido desativado
        if (status === 1) return 'ni ni-box-2';     // Pedido ativo
        if (status === 2) return 'ni ni-check-bold'; // Pedido concluído
        if (status === 5) return 'fas fa-clock'; 
        return ' ni ni-box-2';
      },
     
    getColorByStatus(status:Number) {
        if (status === 0) return 'info'; // Pedido desativado
        if (status === 1) return 'warning';     // Pedido ativo
        if (status === 2) return 'success'; // Pedido concluído
        if (status === 5) return 'danger';
        return '';
      },
    getClassByStatus(status:Number) {
        if (status === 0) return 'pedido-status-desativado-rapida'; // Pedido desativado
        if (status === 1) return 'pedido-status-ativo-rapida';     // Pedido ativo
        if (status === 2) return 'pedido-status-concluido-rapida'; // Pedido concluído
        if (status === 5) return 'pedido-status-aguardando-rapida'; // Pedido concluído
        return '';
      }
    },
    data() {
      return {
        por_pagina : false,
        isLast: false,
      }
    },
    setup(props:any) {
      // Acessando as props diretamente sem usar `this`
      const setCenter = (rota: any) => {
        if (rota.Operacao && rota.Operacao.latitude && rota.Operacao.longitude) {
          const newLocation = {
            lat: parseFloat(rota.Operacao.latitude),
            lng: parseFloat(rota.Operacao.longitude),
          };

          if (props.map && typeof props.map.setCenter === 'function') {
            props.map.setCenter(newLocation); // Define o novo cen tro do mapa
          } else {
            console.error("Mapa inválido ou setCenter não é uma função");
          }
        } else {
          console.error("Coordenadas inválidas ou não fornecidas");
        }
      };

      const setCenterItem = (pedido: any) => {
        if (pedido.latitude && pedido.longitude) {
          const newLocation = {
            lat: parseFloat(pedido.latitude),
            lng: parseFloat(pedido.longitude),
          };

          if (props.map && typeof props.map.setCenter === 'function') {
            props.map.setCenter(newLocation); // Define o novo cen tro do mapa
          } else {
            console.error("Mapa inválido ou setCenter não é uma função");
          }
        } else {
          console.error("Coordenadas inválidas ou não fornecidas");
        }
      };

      // Retorna os métodos ou variáveis que você quer expor
      return {
        setCenter,
        setCenterItem
      };
    }
});
